module.exports = __webpack_public_path__ + "static/media/ristek_logo.48e54f89.jpg";